import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm, Switch } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import categorySlice, { removeCategory, modifyCatDisabled, updateSts } from './categorySlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function CategoryList() {
  const [isDisabled, setIsDisabled] = useState<any>();
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditCategory } = React.useContext(CommonContext) as CommonContextType;
  const Category = useSelector(
    (state: AppState) => state.Category
  );

  useEffect(() => {
    if (Category.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: Category.success.data,
      });

      dispatch(updateSts({}));
    } else if (Category.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: Category.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [Category])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditCategory(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeCategory(id));
  };
  const onToggleChange = (id: any, checked: boolean) => {
    checked = !checked
    setIsDisabled(checked)
    const formData = {
      disabled: checked
    }
    dispatch(modifyCatDisabled(formData, id))
    /* messageApi.open({
      type: 'success',
      content: 'Category updated successfully',
    }); */

  };

  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={Category.CategoryArr}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <img width={70} alt="shape" src={process.env.REACT_APP_AZURE_BLOB_STORAGE_API + item.category_img_url} />
            <div style={{ marginLeft: '40px', width: '40%' }}><b>ID:</b> {index + 1} <br />  <b>Order:</b> {item?.order} <br /> <b>Code:</b> {item.category_code} <br /> <b>Name:</b> {item.category_name}  </div> {/*  <br /> Product Type: {(item?.product_type?.type_name)?item?.product_type?.type_name:'NA'} <br /> Body Size: {(item?.body_size?.bodysize_value)?item?.body_size?.bodysize_value:'NA'} */}
            <Popconfirm title="Sure to update status?" onConfirm={() => onToggleChange(item.id, item.disabled)}>
              <Switch style={{ backgroundColor: item?.disabled ? '#bfbfbf' : '#1577ff' }} checked={item?.disabled} checkedChildren="Disabled" unCheckedChildren="Enabled" />
            </Popconfirm>
          </div>
        </List.Item>
      )}
    />
  );
}